export default __webpack_public_path__ + "static/media/ModoSobDemanda.95b8cc50.png";